import { ErrorPageType } from '@/core/errors'
import { Container, CssBaseline, Typography } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface ErrorPageProps {
  error: ErrorPageType
}

export function ErrorPage(props: ErrorPageProps): JSX.Element {
  const { error } = props
  const { t, ready } = useTranslation('general', { useSuspense: false })
  const status = error.status || 500

  return (
    <Container sx={{ marginTop: '43vh' }}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Typography
          variant="h1"
          align="center"
          sx={{
            fontSize: '2em',
            fontWeight: 300,
            '& strong': {
              fontWeight: 400,
            },
          }}>
          <strong>{ready ? t('error_page_status', { status }) : `Error ${status}`}</strong>:{' '}
          {ready && error.messageKey ? t(error.messageKey) : error.message}
        </Typography>
      </Container>
    </Container>
  )
}
